/**
 * abilityVfxIncinerate — Annie W Incinerate cone flame wave (SP-14).
 */
export function buildIncinerate(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.85 * (spec.scale || 0.95);
  const orange = mat(THREE, spec.color || 0xea580c, 0.92);
  const gold = mat(THREE, 0xfbbf24, 0.95);
  const red = mat(THREE, 0xdc2626, 0.9);
  addFlameTongues(THREE, group, s, orange, red);
  addCoreWave(THREE, group, s, gold, orange);
  addEmberTrail(THREE, group, s, gold);
  group.userData = { shape: 'incinerate' };
  return group;
}

function addFlameTongues(THREE, group, s, orange, red) {
  for (let i = 0; i < 5; i += 1) {
    const spread = (i - 2) * 0.22;
    const tongue = new THREE.Mesh(
      new THREE.ConeGeometry(0.12 * s, 0.85 * s, 5).rotateX(Math.PI / 2),
      i % 2 === 0 ? orange : red
    );
    tongue.position.set(spread * s, 0.2 * s, 0.35 * s);
    if (!tongue.rotation) tongue.rotation = { y: 0 };
    tongue.rotation.y = spread * 0.35;
    group.add(tongue);
  }
}

function addCoreWave(THREE, group, s, gold, orange) {
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.18 * s, 10, 10), gold);
  core.position.set(0, 0.22 * s, 0.1 * s);
  group.add(core);
  const fan = new THREE.Mesh(new THREE.BoxGeometry(0.9 * s, 0.08 * s, 0.55 * s), orange);
  fan.position.set(0, 0.18 * s, 0.45 * s);
  group.add(fan);
}

function addEmberTrail(THREE, group, s, gold) {
  for (let i = 0; i < 3; i += 1) {
    const ember = new THREE.Mesh(new THREE.SphereGeometry(0.06 * s, 8, 8), gold);
    ember.position.set((i - 1) * 0.2 * s, 0.15 * s, -0.25 * s - i * 0.15 * s);
    group.add(ember);
  }
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
